import { Box, BoxProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useCallback, useEffect } from 'react'
import { AepsButton } from '../../../comps/AepsButton'
import { useLazyApiData, useStores } from '../../../data/store'
import { Screens } from '../../../nav/Screens'
import { REFUND_STRINGS } from '../RefundStrings'

export const ActionButtons = ({ values, isValid, customerMobileNumber }: any) => {
  const navigation = useNavigation()

  const { authenticateOtpApi, resendVoucherApi, voucherId, utrTransactionDetails } = useStores((store) => ({
    authenticateOtpApi: store.customer.validateCustomerOtp,
    resendVoucherApi: store.reGenerateRefundCode.resendVoucherApi,
    voucherId: store.reGenerateRefundCode.utrRefRefundDetails.voucherId,
    utrTransactionDetails: store.reGenerateRefundCode.utrRefRefundDetails,
  }))

  const [lazyAuthenticateOtpApi, authenticateOtpHandler] = useLazyApiData(authenticateOtpApi)
  const [lazyResendVoucherApi, resendVoucherApiHandler] = useLazyApiData(resendVoucherApi)
  useEffect(() => {
    if (authenticateOtpHandler.state === 'fulfilled') {
      lazyResendVoucherApi(voucherId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticateOtpHandler.state, navigation])

  useEffect(() => {
    if (resendVoucherApiHandler.state === 'fulfilled') {
      // navigation?.navigate(Screens.REFUND_CODE_REGENERATION_STATUS as never, { item: utrTransactionDetails } as never)
      navigation.reset({
        index: 2,
        routes: [
          {
            name: Screens.REFUND_CODE as never,
          },
          {
            name: Screens.REGENERATE_REFUND_CODE as never,
          },
          {
            name: Screens.REFUND_CODE_REGENERATION_STATUS as never,
            params: {
              item: utrTransactionDetails,
            },
          },
        ],
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resendVoucherApiHandler.state, navigation])

  const onSubmitPress = useCallback(() => {
    if (authenticateOtpHandler.state !== 'fulfilled') {
      lazyAuthenticateOtpApi(values.Otp, customerMobileNumber)
    } else {
      lazyResendVoucherApi(voucherId)
    }
  }, [
    authenticateOtpHandler.state,
    customerMobileNumber,
    lazyAuthenticateOtpApi,
    lazyResendVoucherApi,
    values.Otp,
    voucherId,
  ])

  return (
    <Box {...styles.buttonContainer}>
      <AepsButton
        title={REFUND_STRINGS.confirmRefund}
        onPress={onSubmitPress}
        isLoading={authenticateOtpHandler.state === 'pending'}
        disabled={values.Otp.length !== 6}
        borderRadius={26}
      />
    </Box>
  )
}

const styles = {
  submitButton: {
    borderRadius: 22,
  },
  buttonContainer: {
    justify: 'center',
    pt: 20,
    alignSelf: 'center',
    width: '90%',
    alignContent: 'center',
  } as BoxProps,
}
